import enums from "./../enums";

const cms = (
	state = {
		loading: false,
		containerData: [],
	},
	{ type, payload }
) => {
	switch (type) {
		case enums.CMS_LOADING: {
			return { ...state, loading: payload };
		}
		case enums.CONTAINER_CONTENT: {
			return { ...state, containerData: payload };
		}
		default:
			return { ...state };
	}
};

export default cms;
